import { render, staticRenderFns } from "./ListaSucursal.vue?vue&type=template&id=790ca013"
import script from "./ListaSucursal.vue?vue&type=script&lang=js"
export * from "./ListaSucursal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports